import { BrowserRouter as Router, useRoutes, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

//* import components
import MainPage from './Pages/MainPage/MainPage';
import Home from './Pages/Home/Home';
import Login from "./Pages/Login/Login";
import ExamDetails from './Pages/ExamDetails/ExamDetails';
import SignUp from './Pages/SignUp/SignUp';
import Profile from './Pages/Profile/Profile';
import MyExams from './Pages/MyExams/MyExams';


//* import modals
import Loading from "./Modals/Loader/Loading";

import GlobalStyleOverrides from './GlobalStyleOverrides';
import { ThemeProvider} from '@mui/material/styles';

//* store
import action from "./Redux Store/actions";
import { useDispatch, useSelector } from "react-redux";
import AdmitCards from './Pages/Admit-Cards/AdmitCards';

function App() {
  const dispatch = useDispatch();
  dispatch(action.authCheck());
  const isAuthenticated = useSelector((state) => state.Auth.isAuthenticated);

  const AppWrapper = () => { 
    
    let routes = useRoutes([
      {
        path: '/', element: <Login />,
      },
      {
        path: '/Signup', element: <SignUp />,
      },
      {
        path: '/home',
        element: isAuthenticated ? <MainPage /> : <Navigate to={"/"} />,
        children: [
          {
            path: '', 
            element: <Home /> 
          },
          {
            path: '/home/profile', 
            element: <Profile /> 
          },
          {
            path: '/home/exams', 
            element: <MyExams /> 
          },
          {
            path: '/home/admit-cards', 
            element: <AdmitCards/> 
          },          
          {
            path: '/home/exams/:examShortName', 
            element: <ExamDetails /> 
          },
          
        ]
      },
    ]);
    return routes;
  }

  return (
    <div style={{height: "100%"}}>
      <ThemeProvider theme={GlobalStyleOverrides()}>
        <Router>
          <AppWrapper />
        </Router>
      </ThemeProvider>
      <ToastContainer style={{ fontSize: "1.5rem" }} />
      <Loading />
    </div>
  );
}

export default App;
